import { validate as validateUuid } from 'uuid';

export const isValidUuid = (value: unknown): value is string => {
  if (typeof value !== 'string') return false;
  return validateUuid(value.trim());
};

// why: never fall back to email or another identifier in the profile URL — only FanUsers.uuid is valid here
export const buildProfileHref = (fanUserUuid: string | null | undefined): string | null => {
  if (!isValidUuid(fanUserUuid)) return null;
  return `/profile/${fanUserUuid.trim()}`;
};
